import { isValidRange } from './isValidRange';

/**
 * Dynamically generates valid letters for a given range
 * e.g., "AF" -> ['A', 'B', 'C', 'D', 'E', 'F']
 * e.g., "AK" -> ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K']
 */
export function generateValidLettersForRange(range: string): string[] {
    if (!isValidRange(range)) {
        return [];
    }

    const startLetter = range[0];
    const endLetter = range[1];

    const startCharCode = startLetter.charCodeAt(0);
    const endCharCode = endLetter.charCodeAt(0);

    const letters: string[] = [];
    for (let i = startCharCode; i <= endCharCode; i++) {
        letters.push(String.fromCharCode(i));
    }

    return letters;
}
